<template>

</template>

<script>
// based on github.com/vue-bulma/tooltip
import classNames from 'classnames'
export default {
  name: 'tooltip',
  abstract: true,

  props: {
    type: String,
    size: {
      type: String,
      default: 'medium',
      validator: value => ['small', 'medium', 'large'].includes(value)
    },
    always: Boolean,
    noAnimate: Boolean,
    rounded: Boolean,
    label: {
      type: String,
      default: ''
    },
    placement: {
      type: String,
      default: 'bottom'
    }
  },

  render () {
    let children = this.$slots.default
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(c => c.tag)
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    const rawChild = children[0]

    rawChild.data.attrs = rawChild.data.attrs || {}
    Object.assign(rawChild.data.attrs, {
      'aria-label': this.label
    })

    rawChild.data.class = Array.isArray(rawChild.data.class) ? rawChild.data.class : [rawChild.data.class]
    rawChild.data.class.push(classNames(
      'tooltip',
      `tooltip--${this.placement}`,
      {
        [`tooltip--${this.type}`]: this.type,
        [`tooltip--${this.size}`]: this.size,
        'tooltip--rounded': this.rounded,
        'tooltip--always': this.always,
        'tooltip--no-animate': this.noAnimate
      }
    ))

    return rawChild
  },

  watch: {
    label (val) {
      this.$el.setAttribute('aria-label', val)
    }
  }
}
</script>

<style lang="scss">
@import '~bulma/sass/utilities/functions';
@import '~bulma/sass/utilities/initial-variables';
@import '~bulma/sass/utilities/derived-variables';

$hintPrefix: 'tooltip--';
$hintFontFamily: $family-sans-serif;
$hintTextShadowDarkenAmount: 0;
$hintWarningColor: $warning;
$hintInfoColor: $info;
$hintSuccessColor: $success;

@import '~hint.css/src/hint';

.tooltip--warning:after {
  color: $warning-invert;
}

.#{$hintPrefix}primary {
	@include hint-type($primary);
}

.#{$hintPrefix}danger {
	@include hint-type($danger);
}

.#{$hintPrefix}rounded:after {
  border-radius: $radius;
}

[class*="#{$hintPrefix}"]:after {
  box-shadow: 0 2px 3px rgba(17, 17, 17, 0.1), 0 0 0 1px rgba(17, 17, 17, 0.1);
}
</style>



// WEBPACK FOOTER //
// Tooltip.vue?013740cb